import { getRbacEmployeePermissions, getRbacPrimaryRolePermissions } from "../../services";

export const rbacPermissionsQuery = (objectType: string, targetCompanyId?: string) => ({
	queryKey: ["rbac-permissions", objectType, targetCompanyId ?? null],
	queryFn: () => getRbacPrimaryRolePermissions(objectType, targetCompanyId),
	staleTime: 1000 * 60 * 2,
	meta: {
		errorMessage: "There was an error getting permissions.",
	},
});

export const rbacEmployeePermissionsQuery = (employeeId: string, objectType?: string, disabled = false) => ({
	queryKey: ["rbac-permissions", employeeId, objectType],
	queryFn: async () => {
		const results = await getRbacEmployeePermissions(employeeId, objectType);
		return results;
	},
	staleTime: 1000 * 60 * 2,
	meta: {
		errorMessage: "There was an error getting permissions.",
	},
	enabled: !disabled && !!employeeId,
});
